module.exports = "/public/webpack/img/icon_help_premiumd5e3c04db9fef1079a6901b567c999c7.png";